import {
  Modal,
  NewButton,
  NewButtonVariant,
  Radio,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { requestPoll } from "slices/app/actions/poller";
import { removeErrorMessage } from "slices/app/errorSlice";
import {
  acronymExport,
  statusAcronymExport,
} from "slices/workspace/actions/workspace";

const AnnotatedAcronymReportSelectionModal = ({ documentId, folderId }) => {
  const dispatch = useDispatch();
  const options = [
    {
      text: "Only acronym issues",
      disabled: false,
    },
    {
      text: "All",
      disabled: false,
    },
  ];

  const [selectedOption, setSelectedOption] = useState(options[0].text);

  const modalBody = () => (
    <div className="annotated_acronym_report_selection_modal__body">
      Do you want to output just the issues or output everything?
      <Radio
        options={options}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
      />
    </div>
  );

  const handleClose = () => {
    dispatch(hideModal(modalTypes.ANNOTATED_ACRONYM_REPORT_SELECTION));
  };

  const handleExportSuccess = (job) => {
    handleClose();
    if (job?.data?.jobMetaInfo?.file) {
      window.location = job?.data?.jobMetaInfo?.file;
    }
  };

  const onSubmit = () => {
    dispatch(
      requestPoll(
        acronymExport({
          reportType: "annotatedAcronymDoc",
          folderId,
          docId: documentId,
          onlyAcronymsWithIssues: selectedOption !== "All",
        }),
        statusAcronymExport,
        handleExportSuccess,
        (error) => handleExportFailure(error, dispatch),
        <>
          Sorry we can&apos;t export acronyms at this time, please try again
          later
        </>
      )
    );
    handleClose();
    dispatch(removeErrorMessage());
  };

  return (
    <Modal
      data-testid="annotated-acronym-report-selection-modal"
      className="fade-in annotated_acronym_report_selection_modal"
      show
      onDismiss={handleClose}
      backdrop
      centered
    >
      <Modal.Header>
        <b>Download Annotated Document</b>
      </Modal.Header>
      <Modal.Body>{modalBody()}</Modal.Body>
      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l2}
          onClick={handleClose}
        >
          Cancel
        </NewButton>

        <NewButton
          variant={NewButtonVariant.l1}
          onClick={onSubmit}
          data-testid="ok-button"
        >
          Generate Document
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default AnnotatedAcronymReportSelectionModal;

AnnotatedAcronymReportSelectionModal.propTypes = {
  documentId: PropTypes.string.isRequired,
  folderId: PropTypes.string.isRequired,
};
